module.exports = __webpack_public_path__ + "static/machinelearning1-55f253c7dc5f46fca81f280de8158cb1.png";